// import React from 'react'
import './About.css'


const Aboutpage = () => {
    return (


        <div className='MainBox'>
            
            <div className='MyImg'>
                <img src="https://mir-s3-cdn-cf.behance.net/user/276/637824773629.608777ac4dd81.jpg" alt=''>
                
                </img>
            </div>

           
             <div className='AboutMe'> 
                     <h1>So, who am I?</h1>

                     <div className='bodycopy'>
                             <p>Hi, I'm a <s> UX/UI/Graphic/Web</s> designer with a passion for creating user-friendly and 
                         visually appealing digital experiences. I have a strong background in design principles,
                             user research, and prototyping.
                            </p>
                                 <p>My goal is to design products that not only 
                                     look good but also provide a seamless user experience. 
                                    I believe that great design should be intuitive and accessible to all users.
                                 </p>
                                 <p>In my free time, I enjoy exploring new design trends, 
                                         attending workshops, and collaborating with other designers. 
                                         I'm always looking for opportunities to learn and grow in my field.</p>
                    </div>
                    {/* End of about me classname */}
                </div> 

        </div>
          
    )
}

export default Aboutpage 